/**
 * Fix chirurgico onboarding — FAB "Torna al setup wizard".
 *
 * Appare su ogni pagina interna quando l'utente è arrivato lì partendo dal
 * Setup Wizard (flag in sessionStorage, settato dai link del wizard).
 * Il ritorno riporta a /onboarding senza perdita di sessione; gli step
 * completati restano completati (stato persistito lato backend).
 */
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Rocket, X } from "lucide-react";

export const ONBOARDING_RETURN_FLAG = "ccx_from_onboarding";

export default function OnboardingReturnFab() {
  const location = useLocation();
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const flag = sessionStorage.getItem(ONBOARDING_RETURN_FLAG) === "1";
    setVisible(flag && location.pathname !== "/onboarding");
  }, [location.pathname]);

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-[calc(84px+env(safe-area-inset-bottom,0px))] lg:bottom-6 right-4 z-50 flex items-center gap-1 rounded-full bg-[#102A43] text-white shadow-lg shadow-[#102A43]/30 pl-4 pr-1.5 py-1.5"
      data-testid="onboarding-return-fab"
    >
      <button
        type="button"
        onClick={() => navigate("/onboarding")}
        className="inline-flex items-center gap-2 text-sm font-semibold hover:opacity-90"
        data-testid="onboarding-return-btn"
      >
        <Rocket className="w-4 h-4" /> Torna al setup wizard
      </button>
      <button
        type="button"
        aria-label="Nascondi"
        onClick={() => {
          sessionStorage.removeItem(ONBOARDING_RETURN_FLAG);
          setVisible(false);
        }}
        className="w-7 h-7 grid place-items-center rounded-full hover:bg-white/15"
        data-testid="onboarding-return-dismiss"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
